angular.module('gym.memberships', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.memberships', {
    abstract: true,
    url: '/memberships',
    template: '<ui-view>'
  }).state('gym.memberships.show', {
    url: '/:membershipId',
    template: require('templates/gyms/memberships/show.html.slim')
  });
}]);
